import {Injectable} from '@angular/core';
import {WebService} from './web.service';
import {LocalDataService} from './local-data.service';
import {NavigationService} from './navigation.service';
import {Events} from './events.service';

import {UserObject} from '../objects/user.object';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor(private webService: WebService, private localDataService: LocalDataService, private navigationService: NavigationService, private events: Events) {
	}

	async connexion(username, password) {
		try {
			const conf = {
				url: '/api/login',
				params: {
					username: username,
					password: password
				}
			};
			const result: any = await this.webService.unauthPost(conf);
			if (result?.data?.token) {
				await this.localDataService.setItem('token', result.data.token);
				const userConnected = await this.getUserConnected();
				this.events.publish('userConnected', userConnected);
			} else {
				throw 'LOGIN';
			}
		} catch (error) {
			throw error;
		}
	}

	async deconnexion() {
		await this.localDataService.removeItem('token');
		await this.navigationService.goToInternal('/login');
	}

	async isUserConnected() {
		const token = await this.localDataService.getItem('token');
		return token !== null;
	}

	async getUserConnected() {
		try {
			const conf = {
				url: '/api/auth/user/profile'
			};
			const result: any = await this.webService.get(conf);
			if (result.data) {
				const userConnected = UserObject.LoadFromJSON(result.data);
				await this.localDataService.setItem('userConnected', userConnected);
				return userConnected;
			} else {
				throw 'USER_PROFILE';
			}
		} catch (error) {
			throw error;
		}
	}

	async getStoredUserConnected() {
		const userConnected = await this.localDataService.getItem('userConnected');
		return userConnected ? UserObject.LoadFromJSON(userConnected) : null;
	}

	async getUsers() {
		try {
			const conf = {
				url: '/api/auth/dolibarr/users',
				params: {
					sqlfilters: '(statut:=:\'1\')'
				}
			};
			const result: any = await this.webService.get(conf);
			let users = [];
			for (const i in result.data) {
				users.push(UserObject.LoadFromJSON(result.data[i]));
			}
			users = users.filter((user: UserObject) => {
				return !user.isAdmin;
			});
			return users.sort((a: UserObject, b: UserObject) => {
				if (a.firstname?.toLowerCase() > b.firstname?.toLowerCase()) {
					return 1;
				}
				if (a.firstname?.toLowerCase() < b.firstname?.toLowerCase()) {
					return -1;
				}
				if (a.lastname?.toLowerCase() > b.lastname?.toLowerCase()) {
					return 1;
				}
				if (a.lastname?.toLowerCase() < b.lastname?.toLowerCase()) {
					return -1;
				}
				return 0;
			});
		} catch (error) {
			throw error;
		}
	}

	usersListForIonicSelectable(users: Array<any>, placeholder = 'Choisir') {
		if (users && users.length > 0) {
			let list = '';
			for (const i in users) {
				list += users[i].full_name;
				if (Number(i) < users.length - 1) {
					list += '\n';
				}
			}
			return list;
		} else {
			return placeholder;
		}
	}
}
